module.exports = __webpack_public_path__ + "static/media/images.3be633c3.jpg";